import ReactModal from 'react-modal'

interface ModalProps {
  children: React.ReactNode
  isOpen: boolean
  contentLabel: string
  closeModal: () => void
  contentStyle?: object
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 12,
    border: 'none',
    padding: 32,
    height: '50%'
  },
  overlay: {
    zIndex: '91',
    backgroundColor: 'rgb(40, 45, 45, 50%)'
  }
}

ReactModal.setAppElement('#__next')

function Modal({ children, isOpen, closeModal, contentStyle }: ModalProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={{
        content: { ...customStyles.content, ...contentStyle },
        overlay: { ...customStyles.overlay }
      }}
      contentLabel="contentLabel"
    >
      <>{children}</>
    </ReactModal>
  )
}

export default Modal
